module.exports = __webpack_public_path__ + "static/media/RideLoginBackground.c7648a98.png";